'use es6';

import ScrollWrapper from 'conversations-visitor-message-history/scrolling/components/ScrollWrapper';
import { withScrollTo } from 'conversations-visitor-message-history/scrolling/components/withScrollTo';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getOffsetTimestamp, getOffsetOrdinal } from 'conversations-message-history/thread-history/operators/getters';
import { hasMessages } from 'conversations-message-history/thread-history/operators/hasMessages';
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import styled from 'styled-components';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import classNames from 'classnames';
import { STUBBED_THREAD_ID } from '../../threads/constants/stubbedThreadId';
import ThreadHistoryError from './ThreadHistoryError';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingSpinnerWrapper = styled(VizExLoadingSpinner).withConfig({
  displayName: "ThreadHistoryFetcher__LoadingSpinnerWrapper",
  componentId: "mpap2q-0"
})(["height:0;margin-top:20px;"]);
const ScrollToWrapper = styled(withScrollTo(ScrollWrapper)).withConfig({
  displayName: "ThreadHistoryFetcher__ScrollToWrapper",
  componentId: "mpap2q-1"
})(["flex:1 1;display:flex;flex-direction:column;align-self:stretch;overflow-y:scroll;overflow-x:hidden;"]);
class ThreadHistoryFetcher extends PureComponent {
  constructor(props) {
    super(props);
    this.scrollWrapper = /*#__PURE__*/createRef();
    this.fetchHistory = this.fetchHistory.bind(this);
  }
  componentDidMount() {
    const {
      current
    } = this.scrollWrapper;
    if (current) current.scrollToBottom();
    this.fetchHistory();
  }
  componentDidUpdate(prevProps) {
    const {
      threadId,
      messageCount,
      shouldScrollToBottom,
      isOnFocus
    } = this.props;
    const {
      threadId: prevThreadId,
      messageCount: prevMessageCount,
      shouldScrollToBottom: prevshouldScrollToBottom,
      isOnFocus: prevIsOnFocus
    } = prevProps;
    const {
      current
    } = this.scrollWrapper;
    if (threadId !== prevThreadId) {
      this.fetchHistory();
      if (current) current.scrollToBottom();
      return;
    }
    if (!prevMessageCount) {
      if (current) current.scrollToBottom();
      return;
    }
    if (messageCount !== prevMessageCount) {
      if (current) current.scrollToBottomIfInThreshold();
    }
    if (shouldScrollToBottom !== prevshouldScrollToBottom && current) {
      current.scrollToBottomIfInThreshold();
    }
    if (isOnFocus !== prevIsOnFocus && current) {
      current.scrollToBottomIfInThreshold();
    }
  }
  fetchHistory() {
    const {
      fetchThreadHistory,
      threadId,
      threadHistory,
      sessionId
    } = this.props;
    if (threadId === STUBBED_THREAD_ID) {
      return;
    }
    fetchThreadHistory({
      offsetOrdinal: getOffsetOrdinal(threadHistory),
      offsetTimestamp: getOffsetTimestamp(threadHistory),
      threadId,
      sessionId
    });
  }
  render() {
    const {
      children,
      isLoadingHistory,
      loadingHistoryFailed,
      threadId,
      threadHistory
    } = this.props;
    if (isLoadingHistory && !hasMessages(threadHistory)) {
      return /*#__PURE__*/_jsx(VizExLoadingSpinner, {
        grow: true
      });
    }
    if (loadingHistoryFailed && !hasMessages(threadHistory)) {
      return /*#__PURE__*/_jsx(ThreadHistoryError, {});
    }
    const className = classNames(this.props.className, 'messages-scroll-container-utv');
    return /*#__PURE__*/_jsx(ScrollToWrapper, {
      className: className,
      ref: this.scrollWrapper,
      onScrollToTop: this.fetchHistory,
      stickToTop: isLoadingHistory && /*#__PURE__*/_jsx(LoadingSpinnerWrapper, {
        grow: true
      }),
      children: children
    }, threadId);
  }
}
ThreadHistoryFetcher.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fetchThreadHistory: PropTypes.func.isRequired,
  isLoadingHistory: PropTypes.bool,
  isOnFocus: PropTypes.bool.isRequired,
  loadingHistoryFailed: PropTypes.bool,
  messageCount: PropTypes.number.isRequired,
  sessionId: PropTypes.string.isRequired,
  shouldScrollToBottom: PropTypes.bool.isRequired,
  threadHistory: RecordPropType('ThreadHistory'),
  threadId: PropTypes.number.isRequired
};
ThreadHistoryFetcher.displayName = 'ThreadHistoryFetcher';
export default ThreadHistoryFetcher;